/**
 * Where to send the user when the admin session ends (logout or global 401).
 * Admin V2 has no native login screen; auth starts from legacy Vue 2 admin (`development_admin`).
 *
 * After login, Vue 2 redirects to **`VUE_APP_NEW_URL`** with `access_token` + `refresh_token` query params
 * (`development_admin` Helpers.ts → `setAuthUserData`). That URL must be your Admin **V2** app origin.
 *
 * **If refresh-token fails** (expired access JWT + failed refresh), users see:
 *   Admin V2 → this URL (Vue 2 `/login?logout=1`) → after login → `VUE_APP_NEW_URL?tokens` → Admin V2 again.
 * Staging issues: wrong `VITE_APP_BASE_URL`, CORS, or `SECRET_KEY` mismatch on API; use browser Network tab
 * on `POST .../refresh-token` and console `[Admin V2] POST refresh-token failed`.
 */
export function getAdminSessionEntryUrl(): string {
  const raw = (import.meta.env.VITE_VUE2_APP_URL as string | undefined)?.trim();
  if (!raw) {
    return `${window.location.origin}/login?logout=1`;
  }

  try {
    return `${raw.replace(/\/$/, '')}/login?logout=1`;
  } catch {
    return `${window.location.origin}/login?logout=1`;
  }
}
